import axios from 'axios';

export const promptChainApi = {

  resolveInputs(payload) {
    return axios.post('/externalContent/resolvePromptChainInputs', payload);
  },

  executeChain(payload) {
    return axios.post('/externalContent/executePromptChain', payload);
  },

  triggerChain(payload) {
    return axios.post('/externalContent/triggerPromptChain', payload);
  },

  getExecutionStatus(executionId) {
    return axios.get(`/externalContent/execution/${executionId}/status`);
  },

  getExecutionResult(executionId) {
    return axios.get(`/externalContent/execution/${executionId}/result`);
  },

  getExecutionDetails(executionId) {
    return axios.get(`/externalContent/execution/${executionId}/details`);
  },

  submitSelection(executionId, selectedItems, selectedIndices) {
    return axios.post('/externalContent/submitChainSelection', {
      executionId,
      selectedItems,
      selectedIndices
    });
  },

  getExecutionHistory(chainId) {
    return axios.get(`/externalContent/promptChainExecutionHistory/${chainId}`);
  },

  getExecutionsByDocument(chainId, docId) {
    return axios.get(`/externalContent/promptChainExecutionsByDocument/${chainId}/${docId}`);
  },

  getExecutionsBySourceData(chainId, systemReference, factor) {
    return axios.get(`/externalContent/promptChainExecutionsBySourceData/${chainId}`, {
      params: { system_reference: systemReference, factor }
    });
  },

  // `textHash` (optional): only executions run against this source text — see
  // @rm-ui/levelling/sourceTextHash. Without it, any completed run for the
  // role is returned, whatever document it analysed.
  getExecutionsBySystemRef(chainId, systemReference, textHash = null) {
    return axios.get(`/externalContent/promptChainExecutionsBySystemRef/${chainId}`, {
      params: { system_reference: systemReference, ...(textHash ? { text_hash: textHash } : {}) }
    });
  },

  getExecutionSteps(executionId) {
    return axios.get(`/externalContent/promptChainExecutionSteps/${executionId}`);
  },

  getChainReport(chainId) {
    return axios.get(`/externalContent/promptChainReport/${chainId}`);
  },

  getExecutionReport(executionId) {
    return axios.get(`/externalContent/executionReport/${executionId}`);
  },

  getChainInputRequirements(chainId, triggerId) {
    return axios.get(`/externalContent/chainInputRequirements/${chainId}/${triggerId}`);
  },

  executeExcelSession(payload) {
    return axios.post('/externalContent/executeExcelChainSession', payload);
  },

  executeBulkSession(payload) {
    return axios.post('/externalContent/executeBulkChainSession', payload);
  },

  getExcelSessionStatus(sessionId) {
    return axios.get(`/externalContent/excelSessionStatus/${sessionId}`);
  }
};

export const documentCreationApi = {

  createDocumentRequest(payload) {
    return axios.post('/document/docCreationRequest', payload);
  },

  getDocumentStatus(requestId) {
    return axios.get(`/document/docCreationRequestState/${requestId}`);
  }
};

export default {
  ...promptChainApi,
  document: documentCreationApi
};
